var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37548 9.2915H2.16715V14.8332C2.16715 15.7064 2.87727 16.4165 3.75048 16.4165H13.2505C14.1237 16.4165 14.8338 15.7064 14.8338 14.8332V9.2915H15.6255C15.782 9.29147 15.9351 9.24502 16.0652 9.15803C16.1954 9.07104 16.2968 8.94741 16.3567 8.80277C16.4166 8.65813 16.4323 8.49898 16.4018 8.34543C16.3712 8.19189 16.2959 8.05084 16.1852 7.94013L9.06019 0.815125C8.98674 0.741543 8.89949 0.683168 8.80345 0.643338C8.70741 0.603509 8.60446 0.583008 8.50048 0.583008C8.39651 0.583008 8.29356 0.603509 8.19752 0.643338C8.10148 0.683168 8.01423 0.741543 7.94078 0.815125L0.815774 7.94013C0.705092 8.05084 0.62972 8.19189 0.599187 8.34543C0.568654 8.49898 0.584332 8.65813 0.644237 8.80277C0.704143 8.94741 0.805587 9.07104 0.935744 9.15803C1.0659 9.24502 1.21893 9.29147 1.37548 9.2915ZM6.91715 14.8332V10.8748H10.0838V14.8332H6.91715ZM8.50048 2.49425L13.2505 7.24425V10.8748L13.2513 14.8332H11.6672V10.8748C11.6672 10.0016 10.957 9.2915 10.0838 9.2915H6.91715C6.04394 9.2915 5.33382 10.0016 5.33382 10.8748V14.8332H3.75048V7.24425L8.50048 2.49425Z",
    fill: "#861DF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.55048af88a12d6d3b7f378c9072b6e13.svg";
export { ForwardRef as ReactComponent };